// extracted by mini-css-extract-plugin
export default {"title":"modalInfo_title__3SnOI","text":"modalInfo_text__hg7H-","button":"modalInfo_button__7LqOk","loader":"modalInfo_loader__E89zj"};